export const ACCESS_COMPONENTS = {
  // Week 1 Components - Grammar
  "access/week1/grammar/CoherenceCohesionContent": () =>
    import("../access/week1/grammar/CoherenceCohesionContent"),

  // Week 1 Components - Listening
  "access/week1/listening/PasswordListeningOverviewContent": () =>
    import("../access/week1/listening/PasswordListeningOverviewContent"),

  // Week 1 Components - Reading
  "access/week1/reading/PasswordReadingOverviewContent": () =>
    import("../access/week1/reading/PasswordReadingOverviewContent"),

  // Week 1 Components - Review
  "access/week1/review/Week1ReviewContent": () =>
    import("../access/week1/review/Week1ReviewContent"),

  // Week 1 Components - Speaking
  "access/week1/speaking/PasswordSpeakingOverviewContent": () =>
    import("../access/week1/speaking/PasswordSpeakingOverviewContent"),

  // Week 1 Components - Writing
  "access/week1/writing/PasswordWritingOverviewContent": () =>
    import("../access/week1/writing/PasswordWritingOverviewContent"),

  // Week 2 Components - Grammar
  "access/week2/grammar/TimeWordsContent": () =>
    import("../access/week2/grammar/TimeWordsContent"),

  // Week 2 Components - Listening
  "access/week2/listening/ListeningSection1ContinuedContent": () =>
    import("../access/week2/listening/ListeningSection1ContinuedContent"),

  // Week 2 Components - Reading
  "access/week2/reading/WhenWhereClausesContent": () =>
    import("../access/week2/reading/WhenWhereClausesContent"),

  // Week 2 Components - Review
  "access/week2/review/Week2ReviewContent": () =>
    import("../access/week2/review/Week2ReviewContent"),

  // Week 2 Components - Speaking
  "access/week2/speaking/ReadingAloudTechniquesContent": () =>
    import("../access/week2/speaking/ReadingAloudTechniquesContent"),

  // Week 2 Components - Writing
  "access/week2/writing/TopicSentencesRelativeClausesContent": () =>
    import("../access/week2/writing/TopicSentencesRelativeClausesContent"),

  // Week 3 Components - Grammar
  "access/week3/grammar/VerbPatternsContent": () =>
    import("../access/week3/grammar/VerbPatternsContent"),

  // Week 3 Components - Listening
  "access/week3/listening/ListeningSection2TrueFalseContent": () =>
    import("../access/week3/listening/ListeningSection2TrueFalseContent"),

  // Week 3 Components - Reading
  "access/week3/reading/ReadingSection2GapFillContent": () =>
    import("../access/week3/reading/ReadingSection2GapFillContent"),

  // Week 3 Components - Review
  "access/week3/review/Week3ReviewContent": () =>
    import("../access/week3/review/Week3ReviewContent"),

  // Week 3 Components - Speaking
  "access/week3/speaking/SpeakingSection2SimpleQuestionsContent": () =>
    import("../access/week3/speaking/SpeakingSection2SimpleQuestionsContent"),

  // Week 3 Components - Writing
  "access/week3/writing/EssayStructureIntroductionsContent": () =>
    import("../access/week3/writing/EssayStructureIntroductionsContent"),

  // Week 4 Components - Grammar
  "access/week4/grammar/NounsNounPhrasesClausesContent": () =>
    import("../access/week4/grammar/NounsNounPhrasesClausesContent"),

  // Week 4 Components - Listening
  "access/week4/listening/ListeningSection2NoteTakingContent": () =>
    import("../access/week4/listening/ListeningSection2NoteTakingContent"),

  // Week 4 Components - Reading
  "access/week4/reading/ThatThisTheseThoseContent": () =>
    import("../access/week4/reading/ThatThisTheseThoseContent"),

  // Week 4 Components - Review
  "access/week4/review/Week4ReviewContent": () =>
    import("../access/week4/review/Week4ReviewContent"),

  // Week 4 Components - Speaking
  "access/week4/speaking/SpeakingSection2DetailedAnswersContent": () =>
    import("../access/week4/speaking/SpeakingSection2DetailedAnswersContent"),

  // Week 4 Components - Writing
  "access/week4/writing/BodyParagraphsDevelopmentContent": () =>
    import("../access/week4/writing/BodyParagraphsDevelopmentContent"),

  // Week 5 Components - Grammar
  "access/week5/grammar/VerbTensesOverviewContent": () =>
    import("../access/week5/grammar/VerbTensesOverviewContent"),

  // Week 5 Components - Listening
  "access/week5/listening/ListeningSection3ConnectedSpeechContent": () =>
    import("../access/week5/listening/ListeningSection3ConnectedSpeechContent"),

  // Week 5 Components - Reading
  "access/week5/reading/ReadingSection3MCQContent": () =>
    import("../access/week5/reading/ReadingSection3MCQContent"),

  // Week 5 Components - Review
  "access/week5/review/Week5ReviewContent": () =>
    import("../access/week5/review/Week5ReviewContent"),

  // Week 5 Components - Speaking
  "access/week5/speaking/SpeakingSection3SituationsContent": () =>
    import("../access/week5/speaking/SpeakingSection3SituationsContent"),

  // Week 5 Components - Writing
  "access/week5/writing/SupportingIdeasCohesionContent": () =>
    import("../access/week5/writing/SupportingIdeasCohesionContent"),

  // Week 6 Components - Grammar
  "access/week6/grammar/WordFormsPrefixesSuffixesContent": () =>
    import("../access/week6/grammar/WordFormsPrefixesSuffixesContent"),

  // Week 6 Components - Listening
  "access/week6/listening/VowelLinkingConnectedSpeechContent": () =>
    import("../access/week6/listening/VowelLinkingConnectedSpeechContent"),

  // Week 6 Components - Reading
  "access/week6/reading/ReadingSection3StrategiesContent": () =>
    import("../access/week6/reading/ReadingSection3StrategiesContent"),

  // Week 6 Components - Review
  "access/week6/review/Week6ReviewContent": () =>
    import("../access/week6/review/Week6ReviewContent"),

  // Week 6 Components - Speaking
  "access/week6/speaking/ExpressingPossibilityContent": () =>
    import("../access/week6/speaking/ExpressingPossibilityContent"),

  // Week 6 Components - Writing
  "access/week6/writing/ParallelStructureUnityContent": () =>
    import("../access/week6/writing/ParallelStructureUnityContent"),

  // Week 7 Components - Grammar
  "access/week7/grammar/ParaphrasingNominalisationContent": () =>
    import("../access/week7/grammar/ParaphrasingNominalisationContent"),

  // Week 7 Components - Listening
  "access/week7/listening/ListeningSection4LongerTalksContent": () =>
    import("../access/week7/listening/ListeningSection4LongerTalksContent"),

  // Week 7 Components - Reading
  "access/week7/reading/ReadingSection4HeadingMatchingContent": () =>
    import("../access/week7/reading/ReadingSection4HeadingMatchingContent"),

  // Week 7 Components - Review
  "access/week7/review/Week7ReviewContent": () =>
    import("../access/week7/review/Week7ReviewContent"),

  // Week 7 Components - Speaking
  "access/week7/speaking/SpeakingSection4ComparingIdeasContent": () =>
    import("../access/week7/speaking/SpeakingSection4ComparingIdeasContent"),

  // Week 7 Components - Writing
  "access/week7/writing/AcademicStyleHedgingContent": () =>
    import("../access/week7/writing/AcademicStyleHedgingContent"),

  // Week 8 Components - Grammar
  "access/week8/grammar/RelativeClausesContent": () =>
    import("../access/week8/grammar/RelativeClausesContent"),

  // Week 8 Components - Listening
  "access/week8/listening/ListeningSection4WordMeaningsContent": () =>
    import("../access/week8/listening/ListeningSection4WordMeaningsContent"),

  // Week 8 Components - Reading
  "access/week8/reading/ReadingSection4PracticeContent": () =>
    import("../access/week8/reading/ReadingSection4PracticeContent"),

  // Week 8 Components - Review
  "access/week8/review/Week8ReviewContent": () =>
    import("../access/week8/review/Week8ReviewContent"),

  // Week 8 Components - Speaking
  "access/week8/speaking/SpeakingSection4PracticeContent": () =>
    import("../access/week8/speaking/SpeakingSection4PracticeContent"),

  // Week 8 Components - Writing
  "access/week8/writing/BeingConciseAccuracyContent": () =>
    import("../access/week8/writing/BeingConciseAccuracyContent"),

  // Week 9 Components - Grammar
  "access/week9/grammar/AdverbialClausesContent": () =>
    import("../access/week9/grammar/AdverbialClausesContent"),

  // Week 9 Components - Listening
  "access/week9/listening/ListeningSection5TwoSpeakersContent": () =>
    import("../access/week9/listening/ListeningSection5TwoSpeakersContent"),

  // Week 9 Components - Reading
  "access/week9/reading/ReadingSection5SummaryMatchingContent": () =>
    import("../access/week9/reading/ReadingSection5SummaryMatchingContent"),

  // Week 9 Components - Review
  "access/week9/review/Week9ReviewContent": () =>
    import("../access/week9/review/Week9ReviewContent"),

  // Week 9 Components - Speaking
  "access/week9/speaking/SpeakingSection5ChartsGraphsContent": () =>
    import("../access/week9/speaking/SpeakingSection5ChartsGraphsContent"),

  // Week 9 Components - Writing
  "access/week9/writing/AcademicVocabularyCollocationsContent": () =>
    import("../access/week9/writing/AcademicVocabularyCollocationsContent"),

  // Week 10 Components - Grammar
  "access/week10/grammar/FrontingInversionCleftingContent": () =>
    import("../access/week10/grammar/FrontingInversionCleftingContent"),

  // Week 10 Components - Listening
  "access/week10/listening/ListeningSection5SignalWordsContent": () =>
    import("../access/week10/listening/ListeningSection5SignalWordsContent"),

  // Week 10 Components - Reading
  "access/week10/reading/ReadingSection5PracticeContent": () =>
    import("../access/week10/reading/ReadingSection5PracticeContent"),

  // Week 10 Components - Review
  "access/week10/review/Week10ReviewContent": () =>
    import("../access/week10/review/Week10ReviewContent"),

  // Week 10 Components - Speaking
  "access/week10/speaking/SpeakingSection5PreparationContent": () =>
    import("../access/week10/speaking/SpeakingSection5PreparationContent"),

  // Week 10 Components - Writing
  "access/week10/writing/FormalVocabularyAlternativesContent": () =>
    import("../access/week10/writing/FormalVocabularyAlternativesContent"),

  // Week 11 Components - Grammar
  "access/week11/grammar/GrammarReviewCohesionContent": () =>
    import("../access/week11/grammar/GrammarReviewCohesionContent"),

  // Week 11 Components - Listening
  "access/week11/listening/ListeningReviewSections1to3Content": () =>
    import("../access/week11/listening/ListeningReviewSections1to3Content"),

  // Week 11 Components - Reading
  "access/week11/reading/ReadingReviewSections1to2Content": () =>
    import("../access/week11/reading/ReadingReviewSections1to2Content"),

  // Week 11 Components - Review
  "access/week11/review/Week11ReviewContent": () =>
    import("../access/week11/review/Week11ReviewContent"),

  // Week 11 Components - Speaking
  "access/week11/speaking/SpeakingReviewSections1to2Content": () =>
    import("../access/week11/speaking/SpeakingReviewSections1to2Content"),

  // Week 11 Components - Writing
  "access/week11/writing/WritingReviewOrganisationContent": () =>
    import("../access/week11/writing/WritingReviewOrganisationContent"),

  // Week 12 Components - Grammar
  "access/week12/grammar/GrammarFinalReviewContent": () =>
    import("../access/week12/grammar/GrammarFinalReviewContent"),

  // Week 12 Components - Listening
  "access/week12/listening/ListeningReviewSections4to5Content": () =>
    import("../access/week12/listening/ListeningReviewSections4to5Content"),

  // Week 12 Components - Reading
  "access/week12/reading/ReadingReviewSections3to5Content": () =>
    import("../access/week12/reading/ReadingReviewSections3to5Content"),

  // Week 12 Components - Review
  "access/week12/review/Week12ReviewContent": () =>
    import("../access/week12/review/Week12ReviewContent"),

  // Week 12 Components - Speaking
  "access/week12/speaking/SpeakingFinalReviewContent": () =>
    import("../access/week12/speaking/SpeakingFinalReviewContent"),

  // Week 12 Components - Writing
  "access/week12/writing/WritingFinalReviewContent": () =>
    import("../access/week12/writing/WritingFinalReviewContent"),
} as const;
